export const experienceData = [
    {
      position: "Front End Developer",
      company: "I-Hub Tech",
      location: "San Francisco, CA",
      startDate: "February 2020",
      endDate: "Present", // or "May 2022" if applicable
      responsibilities: [
        "Developed and maintained user-friendly, responsive web applications using modern front-end technologies such as React, HTML5, and CSS3.",
        "Collaborated closely with UX/UI designers to implement visually appealing and intuitive user interfaces.",
        "Implemented and optimized web performance and accessibility standards.",
        "Integrated third-party APIs to enhance application functionality.",
        "Participated in agile development processes, including sprint planning, daily stand-ups, and retrospective meetings.",
        // Add more responsibilities and achievements as needed
      ],
      achievements: [
        "Successfully delivered key features ahead of schedule, contributing to project milestones.",
        "Received recognition for implementing a performance optimization resulting in a 20% reduction in page load times.",
        "Developed a reusable component library, streamlining UI development across multiple projects.",
        "Contributed to a significant increase in user engagement by implementing interactive and dynamic UI elements.",
        // Add more achievements as needed
      ],
    },
    {
      position: "Back End Developer",
      company: "ABC Corp",
      location: "New York, NY",
      startDate: "June 2021",
      endDate: "September 2023", // Update with actual end date
      responsibilities: [
        "Designed, developed, and maintained scalable and efficient server-side solutions using technologies like Node.js and Express.",
        "Provided mentorship to junior developers, conducted code reviews, and enforced coding standards.",
        "Collaborated with cross-functional teams to define and refine project requirements.",
        "Implemented robust RESTful APIs and ensured data integrity through effective database design.",
        // Add more responsibilities as needed
      ],
      achievements: [
        "Led a major system overhaul, resulting in a 30% improvement in response times and increased system reliability.",
        "Received an Employee of the Month award for outstanding contributions to a critical project.",
        "Introduced automated testing procedures, reducing the number of production bugs by 25%.",
        "Initiated and implemented a knowledge-sharing program, fostering a culture of continuous learning within the team.",
        // Add more achievements as needed
      ],
    },
    {
      position: "Full Stack Developer",
      company: "Tech Innovators",
      location: "Seattle, WA",
      startDate: "April 2019",
      endDate: "December 2021", // Update with actual end date
      responsibilities: [
        "Developed end-to-end features for web applications using a combination of front-end and back-end technologies.",
        "Collaborated with product managers to gather and analyze project requirements.",
        "Implemented RESTful APIs and integrated third-party services for enhanced functionality.",
        "Conducted code reviews, mentored junior developers, and actively contributed to the team's growth.",
        // Add more responsibilities as needed
      ],
      achievements: [
        "Successfully delivered multiple projects on time, meeting or exceeding client expectations.",
        "Introduced a modular architecture that improved code maintainability and scalability.",
        "Received recognition for resolving critical production issues and ensuring system stability.",
        "Participated in hackathons, securing first place in a company-wide coding competition.",
        // Add more achievements as needed
      ],
    },
    
    {
      position: "UI/UX Designer",
      company: "Design Studio",
      location: "Chicago, IL",
      startDate: "January 2020",
      endDate: "August 2022", // Update with actual end date
      responsibilities: [
        "Designed and implemented user interfaces for web and mobile applications.",
        "Collaborated with development teams to ensure seamless integration of design concepts.",
        "Conducted user research and usability testing to inform design decisions.",
        "Created wireframes, prototypes, and design specifications for development teams.",
        // Add more responsibilities as needed
      ],
      achievements: [
        "Received positive client feedback for visually appealing and intuitive interface designs.",
        "Improved user engagement by 25% through the implementation of user-centric design principles, evidenced by project X and Y.",
        "Streamlined the design process, reducing time-to-market for new features.",
        "Conducted design workshops for team members, fostering a design-thinking culture.",
        // Add more achievements as needed
      ],
    },
    
    
    {
      position: "DevOps Engineer",
      company: "Cloud Solutions Inc.",
      location: "Austin, TX",
      startDate: "September 2018",
      endDate: "November 2023", // Update with actual end date
      responsibilities: [
        "Implemented and maintained CI/CD pipelines for automating software delivery.",
        "Managed cloud infrastructure and optimized system performance.",
        "Collaborated with development and operations teams to ensure smooth deployments.",
        "Implemented security measures and conducted regular system audits.",
        // Add more responsibilities as needed
      ],
      achievements: [
        "Reduced deployment time by 40% through the implementation of efficient CI/CD practices.",
        "Implemented infrastructure as code (IaC), improving scalability and reproducibility.",
        "Received recognition for ensuring 99.9% uptime for critical production systems.",
        "Initiated and led training sessions on DevOps best practices for the team.",
        // Add more achievements as needed
      ],
    },
  ];
  


  export const imageData = [
    {
      title: "Urban App",
            desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.  nam beatae doloremque obcaecati recusandae inventore omnis, adipisci ex assumenda.",
      p1: "https://cdn.dribbble.com/users/1999543/screenshots/5290476/media/e5bc7129db6e79b9b06ef7921c9031b3.png?resize=800x600&vertical=center"
    },
    {
      title: "Coparative",
      desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.  nam beatae doloremque obcaecati recusandae inventore omnis, adipisci ex assumenda.",
      p1: "https://cdn.dribbble.com/users/4055530/screenshots/14470799/media/97c3e00a6a537f916bcc33fa5618c0a2.png?resize=1000x750&vertical=center"
    },
    {
      title: "Furey",
      desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.  nam beatae doloremque obcaecati recusandae inventore omnis, adipisci ex assumenda.",
      p1: "https://cdn.dribbble.com/users/4250614/screenshots/9816501/media/2c7351de91d343e44d00515257dd3a28.png?resize=1000x750&vertical=center"
    },
    {
      title: "Weather  Web App",
      desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.  nam beatae doloremque obcaecati recusandae inventore omnis, adipisci ex assumenda.",
      p1: "https://cdn.dribbble.com/userupload/3353060/file/original-daad010b5484296372630b4afcaa5d57.png?resize=752x564"
    }
  ]